import { termsListQueryOption, useCustomQuery } from 'src/hooks/react-query/useCustomQuery.hook'
import { TermsListSpace } from 'src/types/api'
import { telecomConverter } from 'src/hooks/react-hook-form/shared/termsConstants'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import styled from 'styled-components'
import {
  Noto_body2_r14,
  Noto_body3_r12,
  Noto_desc_b10,
  Noto_subheading_b18,
} from 'src/styles/font/NotoSansKrFonts'

const TermsWindowPopup = () => {
  const { telecom, termsKey } = useParamsList()

  const { data: { Body: termsContents = undefined } = {} } =
    useCustomQuery<TermsListSpace.Response>(termsListQueryOption())
  const telecomName = telecomConverter[telecom as string]

  const termsData = termsContents?.[telecomName] as TermsListSpace.TermsType<typeof telecomName>
  const selectTermsData =
    termsData?.[termsKey as keyof TermsListSpace.TermsType<typeof telecomName>]

  return (
    <TermsWindowPopupContainer>
      <h2>{selectTermsData?.Title}</h2>
      <pre dangerouslySetInnerHTML={{ __html: selectTermsData?.Contents || '' }} />
    </TermsWindowPopupContainer>
  )
}
export default TermsWindowPopup

const TermsWindowPopupContainer = styled.div`
  margin: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  > h2 {
    ${Noto_subheading_b18};
  }
  > pre {
    display: flex;
    flex-direction: column;
    gap: 0;
    ${Noto_body3_r12};
    white-space: pre-line;
    overflow-x: hidden;
    overflow-y: scroll;
    ${Noto_body2_r14};
    text-align: left;
    letter-spacing: 0.5px;
    width: 100%;
    ol {
      margin: 3px 0;
      padding-left: 25px;
      display: flex;
      flex-direction: column;
    }
    ol,
    li {
      list-style: auto;
    }
    strong {
      font-weight: 700;
    }
    h2 {
      margin: 3px 0;
    }
    tr {
      border: 1px solid var(--black-10);
      padding: 0;
    }

    td {
      border: 1px solid var(--black-10);
      padding: 2.5px 3px;
    }

    th {
      color: var(--black-60);
      ${Noto_desc_b10};
      text-align: left;
      padding: 10px 12px;
      background-color: var(--black-6);
    }

    table {
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid var(--black-10);
      background: #fff;
      margin: 10px 0;
    }
  }
`
